var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCloseCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 427319851"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7765 13.2765C12.4786 13.5745 11.9955 13.5745 11.6975 13.2765L9 10.579L6.30248 13.2765C6.00452 13.5745 5.52143 13.5745 5.22347 13.2765C4.92551 12.9786 4.92551 12.4955 5.22347 12.1975L7.92099 9.5L5.22347 6.80248C4.92551 6.50452 4.92551 6.02143 5.22347 5.72347C5.52143 5.42551 6.00452 5.42551 6.30248 5.72347L9 8.42099L11.6975 5.72347C11.9955 5.42551 12.4786 5.42551 12.7765 5.72347C13.0745 6.02143 13.0745 6.50452 12.7765 6.80248L10.079 9.5L12.7765 12.1975C13.0745 12.4955 13.0745 12.9786 12.7765 13.2765Z",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseCart);
export default __webpack_public_path__ + "static/media/icon-close-cart.f6cd8a6b8de86eddb21c5deca3f379aa.svg";
export { ForwardRef as ReactComponent };